export default __webpack_public_path__ + "static/media/dice-3.9fd5bcd3.svg";